import React, { useState, useMemo } from 'react'

export default function usePagination(data = [], initialRowsPerPage = 10) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const safeCurrentPage = Math.min(Math.max(currentPage, 1), totalPages);
  const currentData = useMemo(() => {
    const start = (safeCurrentPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return data.slice(start, end);
  }, [data, safeCurrentPage, rowsPerPage]);
   // Change page
  const goToPage = (page) => {
    const newPage = Math.min(Math.max(page, 1), totalPages);
    setCurrentPage(newPage);
  };

  // Change number of rows per page
  const changeRowsPerPage = (newRowsPerPage) => {
    const newTotalPages = Math.ceil(data.length / newRowsPerPage) || 1;
    setRowsPerPage(newRowsPerPage);

    // Keep current page valid if possible
    if (currentPage > newTotalPages) {
      setCurrentPage(newTotalPages);
    }
  };
  
  // const currentData = () => {
  //   const start = (currentPage - 1) * rowsPerPage;
  //   const end = start + rowsPerPage;
  //   return data.slice(start, end);
  // };
  // if (currentPage > totalPages && totalPages > 0) {
  //   setCurrentPage(1);
  // }

  // const goToPage = (page) => {
  //   if (page < 1 || page > totalPages) return;
  //   setCurrentPage(page);
  // }
  // const changeRowsPerPage = (newRowsPerPage) => {
  //   setRowsPerPage(newRowsPerPage);
  //   setCurrentPage(1); // Reset to first page
  // };

  return {
    currentPage: safeCurrentPage,
    totalPages,
    currentData,
    goToPage,
    rowsPerPage,
    changeRowsPerPage
  }
}
